var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.correctEnvIndicator)?_c('div',{class:_vm.envIndicatorClasses},[_c('div',{staticClass:"env-indicator__label"},[_vm._v("\n        "+_vm._s(_vm.Configuration().get("envIndicator").toUpperCase())+"\n    ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }